import { Stack } from '@mui/material';
import React from 'react';
import { Outlet, useParams } from 'react-router';
import { PageContentErrorBoundary } from './app/components/page-content-error-boundary/page-content-error-boundary';
import GlobalNav from './shared/components/global-nav/global-nav';

export const AppLayout: React.FC = () => {
  const { venueId } = useParams<{ venueId?: string }>();
  return (
    <Stack direction="column" sx={{ height: '100vh' }}>
      <GlobalNav />
      <PageContentErrorBoundary>
        <Outlet key={venueId} />
      </PageContentErrorBoundary>
    </Stack>
  );
};
